<template>
  <div class="group" @click="toggle()">
    <button
      type="button"
      :class="{
        'bg-gray-400 group-hover:bg-gray-400': this.isActive === false,
        'bg-bc-blue': this.isActive === true
      }"
      class=" relative inline-flex flex-shrink-0 h-5 w-10 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"
      aria-pressed="false"
    >
      <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
      <span
        aria-hidden="true"
        :class="{
          'translate-x-0': this.isActive === false,
          'translate-x-5': this.isActive === true
        }"
        class=" pointer-events-none inline-block h-4 w-4 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
      ></span>
    </button>

    <slot>
      {{$t('Default text')}}
    </slot>
  </div>
</template>

<script>
export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isActive: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    }
  },
};
</script>

<style lang="scss" scoped></style>
